import { PaymentOption, PaymentOptionDetail } from '@navio/nsdk';

const PAYMENT_OPTION_PRIORITY: PaymentOption[] = [
  PaymentOption.INVOICE,
  PaymentOption.PAY_BEFORE,
  PaymentOption.PAY_AFTER
];

export const getHighestPriorityPaymentOption = (paymentOptions?: PaymentOptionDetail[]): PaymentOption => {
  if (!paymentOptions) {
    return PaymentOption.PAY_BEFORE;
  }
  const enabled = new Set(
    paymentOptions.filter((po) => po.enabled && !po.disabledByServiceOrganization).map((po) => po.option)
  );
  return PAYMENT_OPTION_PRIORITY.find((option) => enabled.has(option)) ?? PaymentOption.PAY_BEFORE;
};
